import cn from "classnames";
import React from "react";
import Style from "./LicensePlateCell.module.css";

function isDetermined(status) {
    return status === "DETERMINED" || status === "DETERMINED_REUSED";
}

const NON_ACTIONABLE_TICKET_STATUSES = new Set(["NEW", "GRACE", "PARKING_GRACE", "WAIT", "CHECK", "DONE", "STOPPED", "PAID"]);

function isNonActionable(status) {
    return NON_ACTIONABLE_TICKET_STATUSES.has(status);
}

const resolveClassName = (row) => {
    const violatorAddress = row?.violatorAddress;
    const status = violatorAddress?.status;
    const locked = !!violatorAddress?.locked;

    if (locked && !isDetermined(status)) {
        return cn(Style.important, Style.red);
    }

    switch (status) {
        case "DETERMINED":
            return cn(Style.important, Style.determined);
        case "DETERMINED_REUSED":
            return cn(Style.important, Style.reused);
        case "UNDETERMINED":
            return isNonActionable(row?.status) ? "" : cn(Style.important, Style.orange);
        default:
            return "";
    }
};


const LicensePlateCell = ({row, isViewer, onOpen}) => {
    if (isViewer) {
        return <div>{row.licensePlate}</div>;
    }

    return (
        <div
            className={cn(Style.clickable, resolveClassName(row))}
            onClick={() => onOpen({row})}
        >
            {row.licensePlate}
        </div>
    );
};

export default LicensePlateCell;
